(function () {
  if (window.__AG_PB_RITUALS_INIT__) return;
  window.__AG_PB_RITUALS_INIT__ = true;

  function setExpanded(root, expanded) {
    var toggle = root.querySelector('.js-ag-pb-rituals-toggle');
    var labelShow = root.getAttribute('data-label-show') || 'Show all rituals';
    var labelHide = root.getAttribute('data-label-hide') || 'Show less';

    root.classList.toggle('is-expanded', expanded);
    root.classList.toggle('is-collapsed', !expanded);

    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? labelHide : labelShow;
    }
  }

  function initRoot(root) {
    if (!root || root._agRitualsReady) return;
    root._agRitualsReady = true;

    setExpanded(root, false);

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('.js-ag-pb-rituals-toggle');
      if (!toggle || !root.contains(toggle)) return;
      var wasExpanded = root.classList.contains('is-expanded');
      setExpanded(root, !wasExpanded);
      /* Height change — re-place block circles (ResizeObserver may lag a frame) */
      window.requestAnimationFrame(function () {
        if (wasExpanded) {
          /* Show less — scroll to top of block (mobile + desktop) after collapse */
          var reduceMotion =
            window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.js-ag-pb-rituals').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
